<template>
  <div class="login-bg">
    <div class="cs-head">
      <div class="head-logo">
        <img src="../.././assets/images/top_logo.png" />
      </div>
    </div>
    <div class="content">
      <div class="login">
        <div class="login-input">
          <div class="text">账户：</div>
          <el-input v-model="theName" placeholder="请输入用户名"></el-input>
        </div>
        <div class="login-input">
          <div class="text">密码：</div>
          <el-input v-model="loginPassWord" placeholder="请输入密码" show-password></el-input>
        </div>
        <div class="btn-login" @click="adminLogin">登录</div>
      </div>
    </div>
    <div class="text-foot">
      <a href="http://www.beian.miit.gov.cn" target="_blank">苏ICP备15035130号</a>
      <span>©2015-<span id="myYear"></span> 曼瑞检测科技(苏州)有限公司</span>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui';
  Vue.use(Input)

  export default {
    name: "login",
    data(){
      return{
        theName:'',
        loginPassWord:'',
      }
    },
    created(){
      let _this = this;
      document.onkeydown = function (event) {
        //检测回车按键事件
        let e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          _this.adminLogin();
        }
      };
    },
    mounted(){
      document.getElementById("myYear").innerHTML=new Date().getFullYear();
    },
    methods: {
      adminLogin() {
        let model = {
          theName: this.theName,
          loginPassWord: this.loginPassWord,
          interfaceVersion: 19000101
        }

        this.$api.post('/hAdminLogin.html', model, jsonObj => {
          console.log("登录");
          console.log(jsonObj);
          this.$message.success(jsonObj.info);
          localStorage.setItem("loginAdminToken",jsonObj.admin.token);
          localStorage.setItem("loginAdminName",jsonObj.admin.theName);
          localStorage.setItem("loginAdminId",jsonObj.admin.tableId);

          let jumpUrl = (jsonObj.adminMenuUrlList && jsonObj.adminMenuUrlList.length > 0) ? jsonObj.adminMenuUrlList[0] : "/"
          if(jumpUrl === 'index') jumpUrl = ""
          location.href="index.html#/"+jumpUrl
        },jsonObj => {
          console.log(jsonObj);
          this.$message.error(jsonObj.info);
        })
      },
    }
  }
</script>

<style scoped lang="less">
  @headH:60px;
  @width:1150px;
  @inputW:330px;
  .login-bg{
    background-color: #f5f6f8;
    padding-bottom: 110px;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .cs-head{
    background: #fff;
    box-shadow: 0px 0px 8px 3px rgba(0,0,0,0.1);
  }
  .head-logo{
    height: @headH;
    width: @width;
    margin: 0 auto;
    img{
      height: 44px;
      margin-top: (@headH - 44)/2;
    }
  }
  .content{
    width: @width - 50px;
    height: 460px;
    margin: 110px auto 80px auto;
    padding: 25px 0;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #fff;
    background-image: url("../login_bg.png");
    background-repeat:no-repeat;
    background-position:top right;
    background-size: 552px 100%;
    .login{
      margin-top: 70px;
      margin-left: 80px;
    }
    .login-input{
      width: @inputW;
      margin-bottom: 23px;
      .text{
        color: #666666;
        margin-bottom: 15px;
      }
    }
    .btn-login{
      width: @inputW;
      height: 42px;
      line-height: 42px;
      background-color: #2c9341;
      color: #fff;
      border-radius: 8px;
      text-align: center;
      margin-top: 40px;
      cursor: pointer;
    }
  }
  .text-foot{
    text-align: center;
    color: #666;
    font-size: 13px;
    a{
      color: #666;
    }
  }
</style>
<style>
  .login-input input{
    background-color: #f5f6f8;
    border: none;
    border-radius: 8px;
  }
</style>
